import { Badge } from "../Badge"
import { PLAN_STATUS_LABELS, PLAN_STATUS_BADGE_VARIANTS } from "../../constants/planStatusBadges"

export const StatusBadge = ({ status }) => {
  const variant = PLAN_STATUS_BADGE_VARIANTS[status] || "locked"
  const text = PLAN_STATUS_LABELS[status] || status

  return <Badge variant={variant} text={text} />
}
